module.exports = __webpack_public_path__ + "static/mofongo-hero-2d7ebcdc9077f0be9f618706a86e333f.png";